module.exports = __webpack_public_path__ + "img/recharge-image.f7b7fba4.png";